import * as Yup from 'yup';


const validProductName = Yup.string()
    .required('this field is requird')
    .min(3, 'name is too short')
    .max(500, 'name is too long')

const validQuantity= Yup.number()
    .required('this fiels is required')
    .moreThan(0, 'it must be needed')

const validPrice= Yup.number()
    .nullable().typeError('Please enter a valid number')
    .moreThan(0, 'it must be needed')

const validBidPrice= Yup.number()
    .required('this fiels is required')
    .moreThan(0, 'it must be needed')

const validBidValidTill= Yup.date()
    .required('this fiels is required')
    .min(new Date(), 'it must be graterthan today date')

const validEmail= Yup.string()
    .required('this fiels is required')
    .matches(/[a-zA-Z0-9@.]/, 'Email can only contain Latin letters & numbers')

const validEmailAllowChars= Yup.string()
    .matches(/[a-zA-Z0-9@.]/, 'Email can only contain Latin letters & numbers')

const validPwd= Yup.string()
    .required('this fiels is required')
    .min(6, 'Password is too short - should be 6 chars minimum')
    .matches(/[a-zA-Z0-9]/, 'Password can only contain Latin letters & numbers')

const validMobNumer= Yup.number()
    .required('this fiels is required')
    .moreThan(1000000000, 'enter valid mobile number')
    .lessThan(9999999999, 'enter valid mobile number')

const validOtp= Yup.number()
    .required('this fiels is required')
    .moreThan(1000, 'enter valid OTP number')
    .lessThan(9999, 'enter valid OTP number')

const validFirstName= Yup.string()
    .required('this fiels is required')
    .min(3, 'name is too short - should be 3 chars minimum')
    .matches(/[a-zA-Z]/, 'Name can only contain only latin letters')

const validPageNo= Yup.number()
    .lessThan(99999999, 'enter valid page no number')

const validComment = Yup.string()
    .min(3, 'name is too short')
    .max(2048, 'name is too long')


export {
    validProductName,
    validQuantity,
    validPrice,
    validBidPrice,
    validBidValidTill,
    validEmail,
    validEmailAllowChars,
    validPwd,
    validMobNumer,
    validOtp,
    validFirstName,
    validPageNo,
    validComment,
};